export const {
  VITE_API_ENDPOINT = '',
  VITE_EXTERNAL_API_ENDPOINT = '',
  VITE_APS_API_ENDPOINT = '',
  VITE_APS_CLIENT_ID = '',
  VITE_APS_CLIENT_SECRET = '',
  VITE_APS_BUCKET = '',
  VITE_ENV = '',
  VITE_MOCK_API_ENABLE = 'none',
  VITE_LOCAL_LOGIN = 'true',
  BOX_CDN_VERSION = '26.0.0',
} = import.meta.env;

export const BOX_CDN_BASE_EN = `https://cdn01.boxcdn.net/platform/elements/${BOX_CDN_VERSION}/en-US`;
export const BOX_CDN_BASE_JA = `https://cdn01.boxcdn.net/platform/elements/${BOX_CDN_VERSION}/ja-JP`;
export const SCREEN_ID = 'Screen-Id';
export const PROJECT_ID = 'projectId';
export const BIM_PROJECT_ID = 'bimProjectId';
export const IS_EXTERNAL = globalThis.location.protocol.includes('https');
export const HEADER_NAME_USER_ID = 'User';
export const HEADER_NAME_SCREEN_ID = 'Screen-ID';
export const HEADER_PROJECT_ID = 'X-Project-Id';
export const HEADER_SCREEN_ID = 'X-Screen-Id';
